import { useState } from "react";
import moment from "moment";
import { getTwoMonthsAgoDate, switchString } from "../../utils/utils";
import { Autocomplete, Button, Input, Modal, Spinner, Toggle } from "src/components";
import downArrow from "src/assets/down-arrow.svg";
import { downloadInvoice, editInvoice, getInvoiceChangeValidationV1, getInvoiceDetails, uploadInvoice } from "src/services/invoice-api";
import { generateUniqueID } from "src/constants/functions";
import InvoiceReject from "./invoice-reject";
import InvoiceReassign from "../invoice-master/InvoiceReassign";
import Contact from "src/assets/Contact.svg";
import { toast } from "src/hooks/useToast";
import { useEventStatus } from "src/hooks/useEventStatus";
import { invoiceActions } from "src/context/invoice-slice";
import { useDispatch } from "react-redux";
import { counterActions } from "src/context/counter-slice";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import EwayDetails from "./InvoiceEntryCards/EwayDetails";
import EscalateToMaster from "./InvoiceEntryCards/EscalateToMaster";
import { useNavigate } from "react-router-dom";

interface InvoiceDetailCardProps {
  status: string;
  data: any;
  checkDataType: boolean;
  viewDetails?: boolean;
  isExpandable?: boolean;
  isExpandedInitial?: boolean;
  isCompleted?: boolean;
  isEntry?: boolean;
  index?: number;
  invoiceData?: any;
  showHeader?: boolean;
  fetchInvoiceDetails?: any;
  tab: number;
  isEwayExempt?: boolean;
  ewayData?: any;
}

const InvoiceDetailCard = ({
  data,
  checkDataType = true,
  status,
  isCompleted = false,
  invoiceData,
  showHeader = true,
  isEwayExempt,
  tab,
  ewayData,
}: InvoiceDetailCardProps) => {
  const [invoiceNumber, setInvoiceNumber] = useState<string>(data?.["Invoice no."]);
  const [invoiceDate, setInvoiceDate] = useState<string>(data?.["Invoice date"]);
  const [qrIRN, setQrIRN] = useState<any>(data?.["QR/IRN"]);
  const [irnNumber, setIrnNumber] = useState<string>(data?.["Irn Number"]);
  const [gstStatus, setGstStatus] = useState<string>(data?.["GST Present"]);
  const [dlValidated, setdlValidated] = useState<string>(data?.["DL Present"]);
  const [mciValid, setMciValid] = useState<string>(data?.["MCI Validated"]);
  const [isExpanded, setIsExpanded] = useState(tab !== 1);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [updateEway, setUpdateEway] = useState(false);
  const [escalateToMasterOpen, setEscalateToMasterOpen] = useState(false);
  const navigate = useNavigate();

  const company_code = invoiceData?.company_code;

  const catTwoAndThree = invoiceData?.einvack_type_code === "Upload E-Inv Aknowledgement Copy separately"
    || invoiceData?.einvack_type_code === "Periodic Bulk Upload of E-Invoice";

  const { withEventCheck } = useEventStatus();

  const [modalStates, setModalStates] = useState({
    reject: false,
    reassign: false,
    hold: false,
  });

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleInputChange = (e: any) => {
    const inputValue = e.target.value;
    setInvoiceNumber(inputValue);
  };

  const verifyStringType = function (input: string) {
    const date = new Date(input);
    const numberRegex = /^\d+$/;
    if (!isNaN(date.getTime()) && input.trim() !== "" && !numberRegex.test(input)) {
      return moment(input).format("DD MMM, YYYY");
    } else {
      return input;
    }
  };

  const handleSubmitInvoice = async () => {

    if (invoiceData?.eWayBillDtl?.einvoice_status === "pending" && !isEwayExempt) {
      toast({ description: "E-Way Bill not verified", variant: "destructive" });
      return;
    }
    if (invoiceDate == undefined || invoiceDate == "" || invoiceDate == null || invoiceDate == " ") {
      toast({ description: "Select Invoice Date before updating", variant: "destructive" });
      return;
    }

    if ((qrIRN == " " || qrIRN == "") && data?.["E-Inv.Applicability"] == "Yes"
      && !catTwoAndThree) {
      toast({ description: "Add QR/IRN", variant: "destructive" });
      return;
    }

    if (invoiceData?.eWayBillDtl?.einvoice_status === "accepted" && !catTwoAndThree
      && (qrIRN === "IRN" || qrIRN === "BOTH") && irnNumber !== invoiceData?.eWayBillDtl?.irn_number) {
      toast({ description: "IRN Number should be same as E-Way Bill IRN Number", variant: "destructive" });
      return;
    }

    // if (((qrIRN == "IRN" || qrIRN == "BOTH") && irnNumber == " ") || irnNumber == "") {
    //   toast({ description: "Add IRN Number", variant: "destructive" });
    //   return;
    // }

    // if (gstStatus == "Yes" && !invoiceData?.counter_gst_number?.trim()) {
    //   toast({ description: "GST not validated", variant: "destructive" });
    //   return;
    // }
    if (gstStatus == "No" && invoiceData?.counter_gst_number?.trim()) {
      toast({ description: "Validate GST Status as YES", variant: "destructive" });
      return;
    }
    // if (dlValidated == "Yes" && !invoiceData?.counter_dl_number?.trim()) {
    //   toast({ description: "DL not validated", variant: "destructive" });
    //   return;
    // }
    // if (mciValid == "Yes" && !invoiceData?.counter_mci_number?.trim()) {
    //   toast({ description: "MCI not validated", variant: "destructive" });
    //   return;
    // }

    // if (data?.["Link Type"] == "DRDS" && mciValid == "Yes" && !invoiceData?.counter_mci_number?.trim()) {
    //   toast({ description: "MCI not validated", variant: "destructive" });
    //   return;
    // }
    if (data?.["Link Type"] == "DRDS" && mciValid == "No" && invoiceData?.counter_mci_number?.trim()) {
      toast({ description: "Validate MCI Validated as YES", variant: "destructive" });
      return;
    }
    // if (data?.["Link Type"] == "DRDS" && mciValid == "No" && !invoiceData?.counter_mci_number?.trim()) {
    //   toast({ description: "MCI not validated", variant: "destructive" });
    //   return;
    // }   //For now, allow to bypass even if mci number is not present in master
    // if (data?.["Link Type"] == "DRDS" && gstStatus == "Yes" && !invoiceData?.counter_gst_number?.trim()) {
    //   toast({ description: "GST not validated", variant: "destructive" });
    //   return;
    // }
    // if (
    //   (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
    //   dlValidated == "Yes" &&
    //   (!invoiceData?.counter_dl_number?.trim() || invoiceData?.counter_dl_number?.trim() == undefined)
    // ) {
    //   toast({ description: "DL not validated", variant: "destructive" });
    //   return;
    // }
    // if (
    //   (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
    //   dlValidated == "No" &&
    //   (!invoiceData?.counter_dl_number?.trim() || invoiceData?.counter_dl_number?.trim() == undefined)
    // ) {
    //   toast({ description: "DL not validated", variant: "destructive" });
    //   return;
    // }
    if (
      (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
      dlValidated == "No" &&
      invoiceData?.counter_dl_number?.trim()
    ) {
      toast({ description: "Validate DL Present as YES", variant: "destructive" });
      return;
    }
    // if (
    //   (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
    //   gstStatus == "Yes" &&
    //   (!invoiceData?.counter_gst_number?.trim() || invoiceData?.counter_gst_number?.trim() == undefined)
    // ) {
    //   toast({ description: "GST not validated", variant: "destructive" });
    //   return;
    // }

    setIsLoading(true);

    const currentDate = new Date(invoiceDate);
    const currentYear = currentDate.getFullYear();
    const financialYearStart = new Date(currentDate.getMonth() >= 3 ? currentYear : currentYear - 1, 3, 1);

    const invoiceAccYear = financialYearStart.getFullYear();

    const payloadToValidateInV1 = {
      "cmpstockistcode": invoiceData?.company_stockist_code,
      "invoicenumber_searchcolumn": invoiceNumber || data?.["Invoice no."] || "",
      "invoice_accyear": invoiceAccYear,
      "company_code": invoiceData?.company_code
    }
    const response = await getInvoiceChangeValidationV1(payloadToValidateInV1)
    if (response?.data?.success !== "success") {
      toast({ description: response?.data?.message, variant: "destructive" });
      setIsLoading(false);
      return;
    }

    const payload = {
      data: {
        invoice_status: invoiceData?.fileStatusHdr?.fuid_status_shortcode,
        stockist_id: invoiceData?.stockist_id,
        stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
        u_code: generateUniqueID(),
        new_invoice_date: invoiceDate,
        invoice_number: invoiceNumber ? invoiceNumber.trim() : data?.["Invoice no."] || "",
        ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
        irn: qrIRN == "IRN" || qrIRN == "BOTH" ? irnNumber.trim() : "",
        gst_validated: gstStatus == "Yes" ? true : false,
        dl_validated: dlValidated == "Yes" ? true : false,
        mci_validated: mciValid == "Yes" ? true : false,
        counter_gst_number: invoiceData?.counter_gst_number || "",
        counter_dl_number: invoiceData?.counter_dl_number || "",
        counter_mci_number: invoiceData?.counter_mci_number || "",
      },
      event_type: "INVOICE_ADD",
    };

    const payload2 = {
      data: {
        invoice_status: invoiceData?.fileStatusHdr?.fuid_status_shortcode,
        invoice_id: invoiceData?.invoice?.invoice_id,
        invoice_number: invoiceNumber?.trim(),
        u_code: invoiceData?.invoice?.u_code,
        new_invoice_date: invoiceDate,
        stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
        stockist_id: invoiceData?.stockist_id,
        ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
        irn: qrIRN == "IRN" || qrIRN == "BOTH" ? irnNumber.trim() : "",
        gst_validated: gstStatus == "Yes" ? true : false,
        dl_validated: dlValidated == "Yes" ? true : false,
        mci_validated: mciValid == "Yes" ? true : false,
        counter_gst_number: invoiceData?.counter_gst_number || "",
        counter_dl_number: invoiceData?.counter_dl_number || "",
        counter_mci_number: invoiceData?.counter_mci_number || "",
        header_edit: true,
        invoice_num_modified: invoiceData?.invoice?.invoice_number?.trim() !== invoiceNumber?.trim(),
        counter_data_validation:
          invoiceData?.invoice?.dl_validated !== (dlValidated == "Yes" ? true : false) ||
          invoiceData?.invoice?.gst_validated !== (gstStatus == "Yes" ? true : false) ||
          invoiceData?.invoice?.mci_validated !== (mciValid == "Yes" ? true : false),
      },
      primary_key: invoiceData?.invoice?.invoice_id,
      event_type: "INVOICE_EDIT",
    };
    try {
      if (invoiceData?.invoice == null) {
        const res = await uploadInvoice(payload, company_code as string);
        const response = await withEventCheck(
          () => {
            return getInvoiceDetails(invoiceData?.stockist_invoice_attachment_id as string, false, company_code as string);
          },
          res?.data?.data?.eventStreamCreated?.streamId
        );
        dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));
      } else {
        const res = await editInvoice(payload2, company_code as string);
        const response = await withEventCheck(
          () => {
            return getInvoiceDetails(invoiceData?.stockist_invoice_attachment_id as string, false, company_code as string);
          },
          res?.data?.data?.invoice?.eventStreamCreated?.streamId
        );
        if (Number(tab) === 1) {
          dispatch(invoiceActions?.setInvoiceApprovalData(response?.data?.data));
        } else {
          dispatch(invoiceActions?.setInvoiceDetails(response?.data?.data));
        }
      }

      setIsLoading(false);
      toast({ description: "Invoice header submitted", variant: "default" });
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
      console.log(error, "error");
      setIsLoading(false);
    }
  };

  const handleCloseModal = (modalName: string) => {
    setModalStates((prev: any) => ({ ...prev, [modalName]: false }));
  };

  return (
    <div className="-mt-10">
      <Modal isOpen={modalStates.reject} isHeader={false} onCloseModal={() => handleCloseModal("reject")} title="Reject Invoice">
        <InvoiceReject invoiceData={invoiceData} onCloseModal={() => handleCloseModal("reject")} />
      </Modal>
      <Modal isOpen={modalStates.reassign} isHeader={false} onCloseModal={() => handleCloseModal("reassign")} title="Reassign Invoice">
        <InvoiceReassign invoiceData={invoiceData} onCloseModal={() => handleCloseModal("reassign")} />
      </Modal>

      {showHeader && (
        <header className={isCompleted ? "flex justify-between w-full" : "flex justify-between w-full px-5 py-5"}>
          <div className="flex flex-col gap-x-2">
            <div className="flex items-center gap-x-2">
              <h1 className="font-semibold text-[1.4rem] mr-4">
                <span className="text-gray-400 text-[1.4rem]">FUID#</span> {invoiceData?.fuid_no}
              </h1>
              <h1
                className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
                style={{
                  backgroundColor: invoiceData?.fileStatusHdr?.color_code?.trim(),
                  color: invoiceData?.fileStatusHdr?.text_color_code?.trim(),
                }}
              >
                {status}
                <img className="w-3 h-3 ml-1" src={downArrow} alt="down-arrow" />
              </h1>
            </div>
          </div>
        </header>
      )}
      {showHeader && (
        <div className="flex justify-between">
          <div className="flex items-center ml-4 gap-x-2">
            <img className="w-6 h-6 ml-1" src={Contact} alt="person-img" />
            <span className="text-[#49484C] text-sm">Assigned to</span>
            <div className="w-10 h-10 bg-[#8051FF] flex items-center justify-center text-[#fff] rounded-full">
              {invoiceData?.InvoiceAssignment?.user_name?.slice(0, 2)}
            </div>
            <span className="text-[#49484C] text-sm">{invoiceData?.InvoiceAssignment?.user_name}</span>
          </div>
          <div className="flex items-center gap-x-2">
            {
              <div className="flex items-center p-2 rounded-md bg-[#f1f1f1]">
                <Button
                  className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
                  onClick={() => {
                    if (!invoiceData?.file_path) {
                      toast({ description: "Invoice not found", variant: "destructive" });
                      return;
                    }
                    downloadInvoice(invoiceData?.file_path, invoiceData?.company_code as string).then((res: any) => {
                      if (res?.data?.success && res?.data?.data) {
                        window.open(res?.data?.data, "_blank");
                      } else {
                        console.error("Failed to download the invoice.");
                      }
                    });
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
                  </svg>
                  <span>Download Invoice</span>
                </Button>
                {invoiceData?.einv_attachment_path && invoiceData?.is_einv_applicable == true && invoiceData?.einvack_type_code !== "Upload IRN/BarCode along with Invoice" && (
                  <Button
                    className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
                    onClick={() => {
                      if (!invoiceData?.einv_attachment_path) {
                        toast({ description: "E-Invoice not found", variant: "destructive" });
                        return;
                      }
                      downloadInvoice(invoiceData?.einv_attachment_path, invoiceData?.company_code as string).then((res: any) => {
                        if (res?.data?.success && res?.data?.data) {
                          window.open(res?.data?.data, "_blank");
                        } else {
                          console.error("Failed to download the E-Invoice.");
                        }
                      });
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
                    </svg>
                    <span>Download E-Invoice</span>
                  </Button>
                )}
                {invoiceData?.eway_attachment_path && invoiceData?.is_eway_applicable == true && (
                  <Button
                    className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
                    onClick={() => {
                      if (!invoiceData?.eway_attachment_path) {
                        toast({ description: "E-Way Bill not found", variant: "destructive" });
                        return;
                      }
                      downloadInvoice(invoiceData?.eway_attachment_path, invoiceData?.company_code as string).then((res: any) => {
                        if (res?.data?.success && res?.data?.data) {
                          window.open(res?.data?.data, "_blank");
                        } else {
                          console.error("Failed to download the Eway Bill.");
                        }
                      });
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
                    </svg>
                    <span>Download E-Way Bill</span>
                  </Button>
                )}
                <Button onClick={() => setEscalateToMasterOpen(true)} className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1]  border-none rounded-none h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span>Escalate to master</span>
                </Button>
                <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 border-l rounded-l-none rounded-r-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636a9 9 0 11-12.728 0m12.728 0L12 12m0 0l-6.364-6.364" />
                  </svg>
                  <span>Report an issue</span>
                </Button>
              </div>
            }
          </div>
        </div>
      )}
      {isLoading ? (
        <div className="flex justify-center items-center h-[20vh]">
          <Spinner />
        </div>
      ) : (
        <div
          className={`overflow-hidden items-center transition-all duration-500 px-5 ease-in-out`}
          style={{ transitionProperty: "max-height, opacity" }}
        >
          <div className="flex justify-between items-center pb-5 mt-10 border-b-2 border-gray-200">
            <div className="flex items-center gap-x-4">
              <p className="text-xl font-semibold">Header Information</p>
              {!isExpanded && (
                <>
                  {invoiceData?.orderCodes?.length > 0 && (
                    <p className="text-sm text-gray-500 border border-gray-300 rounded-lg p-1 px-2">
                      Order Code: {invoiceData?.orderCodes?.map((code: any) => code?.order_code).join(", ")}
                    </p>
                  )}
                </>
              )}
            </div>
            <div className="p-2 bg-[#F1F1F1] border-2 border-gray-200 rounded-md cursor-pointer" onClick={handleToggle}>
              <img className={`transition-transform  duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </div>
          </div>

          <div
            className={`transition-all items-center duration-500 ease-in-out ${isExpanded ? "opacity-100 max-h-[1000px]" : "max-h-0 opacity-0"}`}
            style={{ transitionProperty: "max-height, opacity" }}
          >
            <div className={"grid grid-cols-1 w-[100%] py-5 mt-5 xl:grid-cols-3 gap-y-5"}>
              {!!data &&
                Object.keys(data)?.length > 0 &&
                Object.entries(data)?.map(
                  ([key, value]) =>
                    typeof value === "string" &&
                    value !== "" && (
                      <div key={key?.toString()} className={"grid grid-cols-2 -space-x-10 -space-y-0 text-sm xl:grid-cols-2 items-center"}>
                        {((key !== "MCI Validated" && data?.["Link Type"] !== "DRDS") ||
                          (key !== "DL Present" && (data?.["Link Type"] !== "DRAPH" || data?.["Link Type"] !== "INDPH-PH" || data?.["Link Type"] !== "INDPH-HS")))
                          && <p className="text-[#49484C] place-self-center mr-auto whitespace-break-spaces text-sm leading-[0.02rem] font-normal not-italic">
                            {switchString(key)} :
                          </p>}

                        {key == "GST Present" && (
                          <div className="w-[60%]">
                            <Toggle
                              disabled={
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                // !data?.["GST No."]?.trim()?.length
                              }
                              checked={gstStatus == "Yes"}
                              onChange={(e: any) => {
                                setGstStatus(e === true ? "Yes" : "No");
                              }}
                            />
                          </div>
                        )}
                        {(data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") && key == "DL Present" && (
                          <div className="w-[60%]">
                            <Toggle
                              disabled={
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                // !data?.["DL no."]?.trim()?.length
                              }
                              checked={dlValidated == "Yes"}
                              onChange={(e: any) => {
                                setdlValidated(e === true ? "Yes" : "No");
                              }}
                            />
                          </div>
                        )}

                        {key == "QR/IRN" && !catTwoAndThree && (
                          <div className="w-[60%]">
                            <Autocomplete
                              inputClassName="relative"
                              placeholder={key}
                              defaultValue={qrIRN}
                              suggestionList={[
                                { key: "QR", value: "QR" },
                                { key: "IRN", value: "IRN" },
                                { key: "BOTH", value: "BOTH" },
                              ]}
                              disabled={
                                data?.["E-Inv.Applicability"] == "No" ||
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 ||
                                invoiceData?.fileStatusHdr?.fuid_status_id === 6
                              }
                              onSelectionChange={(e: any) => {
                                if (e === null) {
                                  setQrIRN(null);
                                  return;
                                }
                                setQrIRN(e.value);
                              }}
                              displayKey="key"
                            />
                          </div>
                        )}
                        {(qrIRN === "IRN" || qrIRN === "BOTH") && key === "Irn Number" && (
                          <div className="w-full mt-2">
                            <Input
                              enableArrows={false}
                              showIcon={false}
                              placeholder="IRN Number"
                              type="text"
                              value={irnNumber}
                              disabled={
                                data?.["E-Inv.Applicability"] == "No" ||
                                catTwoAndThree ||
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 ||
                                invoiceData?.fileStatusHdr?.fuid_status_id === 6
                              }
                              isError={invoiceData?.eWayBillDtl?.einvoice_status === "accepted" && !catTwoAndThree
                                && (qrIRN === "IRN" || qrIRN === "BOTH") && irnNumber !== invoiceData?.eWayBillDtl?.irn_number
                              }
                              onChange={(e: any) => setIrnNumber(e.target.value)}
                              className="w-full py-1 text-left border border-gray-300 rounded-lg"
                              errorMessage={invoiceData?.eWayBillDtl?.einvoice_status === "accepted" && !catTwoAndThree
                                && (qrIRN === "IRN" || qrIRN === "BOTH") && irnNumber !== invoiceData?.eWayBillDtl?.irn_number
                                ? "IRN Number should be same as E-Way Bill IRN Number"
                                : ""
                              }
                            />
                          </div>
                        )}
                        {key === "Invoice no." && (
                          <div className="w-[100%]">
                            <Input
                              enableArrows={false}
                              showIcon={false}
                              placeholder={key}
                              type="text"
                              value={invoiceNumber}
                              onChange={handleInputChange}
                              className="w-full py-1 text-left border border-gray-300 rounded-lg"
                            />
                          </div>
                        )}

                        {key === "Invoice date" && (
                          <Input
                            enableArrows={false}
                            showIcon={false}
                            placeholder={key}
                            type="date"
                            value={invoiceDate ? invoiceDate.split("T")[0] : value}
                            max={new Date().toISOString().split("T")[0]}
                             min={getTwoMonthsAgoDate()}
                            className="w-full py-1 text-left border border-gray-300 rounded-lg"
                            onChange={(e: any) => {
                              const dateValue = e.target.value;
                              const selectedDate = new Date(dateValue);

                              const now = new Date();

                              // Set time using UTC values
                              selectedDate.setUTCHours(now.getUTCHours());
                              selectedDate.setUTCMinutes(now.getUTCMinutes());
                              selectedDate.setUTCSeconds(now.getUTCSeconds());
                              selectedDate.setUTCMilliseconds(now.getUTCMilliseconds());

                              const formattedDate = selectedDate.toISOString(); // This will be in UTC
                              setInvoiceDate(formattedDate);
                            }}
                          />
                        )}
                        {data?.["Link Type"] == "DRDS" && key == "MCI Validated" && (
                          <div className="w-[60%]">
                            <Toggle
                              disabled={
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                // !data?.["MCI no."]?.trim()?.length
                              }
                              checked={mciValid == "Yes"}
                              onChange={(e: any) => {
                                setMciValid(e === true ? "Yes" : "No");
                              }}
                            />
                          </div>
                        )}
                        {key === "Order Code" && value?.split(",").map((orderCode, index) => {
                          const trimmedCode = orderCode.trim();
                          return (
                            <span key={index}>
                              <a
                                className="text-gray-900 hover:text-[#6b40d6] w-fit"
                                href={`/transactions/orders/info/${trimmedCode}/1`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => {
                                  window.localStorage.setItem("counterCompanyLocationId", invoiceData?.counter_company_location_id);
                                }}
                              >
                                {trimmedCode}
                              </a>
                              {index < value.split(",").length - 1 && ", "}
                            </span>
                          );
                        })}
                        {key == "Counter code" && (
                          <a
                            className="text-gray-900 hover:text-[#6b40d6]"
                            href={`/masters/counters/details/?counter_code=${value}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                              dispatch(counterActions.setClickType("row"));
                              dispatch(counterActions.setSelectedCounterData({}));
                              window.localStorage.setItem("counterOrderId", value);
                              window.localStorage.setItem("counterCompanyLocationId", invoiceData?.counter_company_location_id);
                            }}
                          >
                            {value}
                          </a>
                        )}
                        {key !== "QR/IRN" &&
                          key !== "DL Present" &&
                          key !== "GST Present" &&
                          key !== "MCI Validated" &&
                          key !== "Irn Number" &&
                          key !== "Invoice no." &&
                          key !== "Invoice date" &&
                          key !== "Order Code" &&
                          key !== "Counter code" && (
                            <div className="mr-auto">
                              {checkDataType && <p className="text-[#1B1A1F] mr-auto">{typeof value === "string" ? verifyStringType(value) : ""}</p>}
                              {!checkDataType && <p className="text-[#1B1A1F] mr-auto">{value}</p>}
                            </div>
                          )}
                      </div>
                    )
                )}
            </div>
            <div className="flex flex-col justify-between pb-5 mt-10">
              <div className="text-xl font-semibold ">Eway Bill Details</div>

              <div className={"grid grid-cols-1 w-[100%] py-5 mt-5 xl:grid-cols-3 gap-y-5"}>
                {!!ewayData &&
                  Object.keys(ewayData)?.length > 0 &&
                  Object.entries(ewayData)?.map(
                    ([key, value]) =>
                      typeof value === "string" &&
                      value !== "" && (
                        <div key={key?.toString()} className={"grid grid-cols-2 -space-x-10 -space-y-0 text-sm xl:grid-cols-2 items-center"}>
                          {
                            <p className="text-[#49484C] place-self-center mr-auto whitespace-break-spaces text-sm leading-[0.02rem] font-normal not-italic">
                              {switchString(key)} :
                            </p>}
                          {
                            <div className="mr-auto">
                              {checkDataType && <p className="text-[#1B1A1F] mr-auto">{typeof value === "string" ? verifyStringType(value) : ""}</p>}
                              {!checkDataType && <p className="text-[#1B1A1F] mr-auto">{value}</p>}
                            </div>
                          }
                        </div>
                      )
                  )}
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mb-10 gap-x-4">
            {!invoiceData?.invoice && <p className="text-gray-700">Please submit the invoice header first!</p>}

            {invoiceData?.eWayBillDtl && invoiceData?.is_eway_applicable && <Button onClick={() => setUpdateEway(true)} className="w-fit h-9 mt-0 font-normal border border-[#D0D0D0]  bg-[#F1F1F1] shadow-sm">Update E-way</Button>}
            <Button
              className="h-9 px-6 text-white font-normal bg-[#8051FF] shadow-sm transition hover:bg-[#6b40d6]"
              type="submit"
              onClick={handleSubmitInvoice}
              isLoading={isLoading}
              disabled={invoiceData?.fileStatusHdr?.fuid_status_id === 8}
              module={
                invoiceData?.invoice
                  ? fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].module
                  : fineGrainedPermissionsKeys.INVOICE.SUBMITINVOICE.module
              }
              action={
                invoiceData?.invoice
                  ? fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].action
                  : fineGrainedPermissionsKeys.INVOICE.SUBMITINVOICE.action
              }
            >
              {invoiceData?.invoice ? "Update Invoice" : "Submit Invoice"}
            </Button>
          </div>
        </div>
      )
      }
      <Modal isOpen={updateEway} isHeader={false} onCloseModal={() => setUpdateEway(false)} title="Eway Bill">
        <EwayDetails isUpadinng={true} onSuccess={async () => {
          const response = await getInvoiceDetails(invoiceData?.stockist_invoice_attachment_id as string, false, company_code as string)
          dispatch(invoiceActions.setInvoiceDetails(response?.data?.data))
          setUpdateEway(false)
        }} onCloseModal={() => {
          setUpdateEway(false)
        }} invoiceData={invoiceData} />
      </Modal>
      <Modal isOpen={escalateToMasterOpen} isHeader={false} onCloseModal={() => setEscalateToMasterOpen(false)}>
        <EscalateToMaster
          onSuccess={() => {
            navigate("/transactions/invoice/0");
          }}
          onCloseModal={() => setEscalateToMasterOpen(false)}
        />
      </Modal>
    </div >
  );
};

export default InvoiceDetailCard;
